import { UserRiskTolerance } from '@fintronners/react-api/src';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export type RiskToleranceAnswerType = {
  label: string;
  description: string;
  value: UserRiskTolerance;
};

export const useRiskTolerancesSurvey = () => {
  const { t } = useTranslation();

  const answers: RiskToleranceAnswerType[] = [
    {
      label: t(`riskTolerance.${UserRiskTolerance.UserRiskToleranceLow}`),
      description: t(`commonRiskTolerance.stocksData.${UserRiskTolerance.UserRiskToleranceLow}`),
      value: UserRiskTolerance.UserRiskToleranceLow,
    },
    {
      label: t(`riskTolerance.${UserRiskTolerance.UserRiskToleranceMedium}`),
      description: t(`commonRiskTolerance.stocksData.${UserRiskTolerance.UserRiskToleranceMedium}`),
      value: UserRiskTolerance.UserRiskToleranceMedium,
    },
    {
      label: t(`riskTolerance.${UserRiskTolerance.UserRiskToleranceHigh}`),
      description: t(`commonRiskTolerance.stocksData.${UserRiskTolerance.UserRiskToleranceHigh}`),
      value: UserRiskTolerance.UserRiskToleranceHigh,
    },
  ];

  const getAnswerFromValue = (value: UserRiskTolerance) => {
    return answers.find((ans) => ans.value === value);
  };

  return { answers, getAnswerFromValue };
};

export const riskProfileSchema = yup.object({
  riskTolerance: yup.string().oneOf(Object.values(UserRiskTolerance)),
});

export type RiskProfileSchemaType = yup.InferType<typeof riskProfileSchema>;
